<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Priority Listings</h3>
        <v-spacer></v-spacer>

        <v-btn
          class="mb-auto mr-3"
          @click="toggleAdvanceSearch"
          dark
          fab
          color="secondary"
        >
          <v-icon>mdi-magnify</v-icon></v-btn
        >

        <v-dialog v-if="modelPermissions.create" persistent v-model="dialog">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-auto"
              dark
              fab
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
          </template>
          <priority-listing-dialog
            v-if="dialog"
            :priority_listings="priority_listings"
            :item="item"
            :close="close"
          ></priority-listing-dialog>
        </v-dialog>
      </v-card-title>

      <v-data-table
        :server-items-length="priority_listings.total"
        :loading="loading"
        :headers="headers"
        :items="priority_listings.data"
        :options.sync="options"
        :items-per-page="5"
      >
        <template v-slot:top>
          <v-expansion-panels disabled multiple v-model="advanceSearch" flat>
            <v-expansion-panel v-for="(item, i) in 1" :key="i">
              <v-expansion-panel-header> </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-toolbar flat>
                    <v-text-field
                      clear-icon
                      clearable
                      v-model.lazy="search"
                      prepend-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <date-picker v-model="fromDate" label="From"></date-picker>
                    <v-spacer></v-spacer>
                    <date-picker v-model="toDate" label="To"></date-picker>
                  </v-toolbar>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <select-categories
                      v-model="category"
                      label="Category"
                    ></select-categories>
                  </v-col>
                  <v-col cols="6">
                    <select-suburbs
                      v-model="suburb"
                      label="Suburb"
                    ></select-suburbs
                  ></v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-if="modelPermissions.edit" v-slot:item.edit="{ item }">
          <v-btn text @click="editItem(item)" color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-if="modelPermissions.delete" v-slot:item.delete="{ item }">
          <v-btn text @click="deleteItem(item)" color="error">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-row>
</template>

<script>
import PriorityListingDialog from './PriorityListingDialog'
import DatePicker from '../../../components/DatePicker'
import SelectSuburbs from '../../../components/SelectSuburbs'
import SelectCategories from '../../../components/SelectCategories'
import axios from '../../../utils/axios'
import { mapGetters } from 'vuex'
export default {
  name: 'PriorityListingIndex',
  components: {
    PriorityListingDialog,
    DatePicker,
    SelectCategories,
    SelectSuburbs
  },
  data() {
    return {
      advanceSearch: [],
      dialog: false,
      loading: false,
      headers: [
        {
          text: 'id',
          value: 'id'
        },
        {
          text: 'Name',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Email',
          align: 'start',
          value: 'email'
        },
        {
          text: 'Messages Sent',
          align: 'start',
          value: 'text_messages_count'
        },

        { text: 'Edit', align: 'center', value: 'edit', sortable: false },
        { text: 'Delete', align: 'center', value: 'delete', sortable: false }
      ],

      priority_listings: [],
      options: {},
      item: {},
      search: '',
      fromDate: '',
      toDate: '',
      category: '',
      suburb: ''
    }
  },
  methods: {
    toggleAdvanceSearch() {
      if (this.advanceSearch.length === 1) {
        this.advanceSearch = []
        this.category = ''
        this.suburb = ''
      } else {
        this.advanceSearch = [0]
      }
    },
    close() {
      this.item = {}
      this.dialog = false
    },
    editItem(item) {
      this.item = item
      this.dialog = true
    },
    getPriorityListings() {
      this.loading = true
      console.log('getting PriorityListing')
      axios
        .get(
          encodeURI(
            `api/admin/priority-listings?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}&category=${this.category}&suburb=${this.suburb}&fromDate=${this.fromDate}&endDate=${this.toDate}`
          )
        )
        .then(res => {
          this.priority_listings = res.data
          this.loading = false
          console.log('done')
        })
    },
    deleteItem(item) {
      if (confirm(`Confirm Delete...${item.id}`)) {
        console.log('deleting priority listing with id ', item.id)
        axios
          .delete(`api/admin/priority-listings/${item.id}`)
          .then(res => {
            console.log(res)
            if (res.data === 1) {
              this.getPriorityListings()
            }
          })
          .catch(err => console.log(err))
      }
    }
  },
  computed: {
    ...mapGetters(['permissions/getModelPermissions']),
    modelPermissions() {
      return this['permissions/getModelPermissions']('priority_listing')
    }
  },
  watch: {
    options: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    },
    dialog: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    },
    search: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    },
    fromDate: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    },
    toDate: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    },
    category: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    },
    suburb: {
      handler() {
        this.getPriorityListings()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
